import { IPasswordResetCredentilas } from '../../../types/auth';
import { AuthActions } from '../actions/authActions';
import * as constants from '../actions/constants';

export const loginStatus = (state = !!localStorage.getItem('user'), action: AuthActions): boolean => {
  switch(action.type) {
    case constants.LOGIN_SUCCESS:
      return true;

    case constants.LOGIN_HAS_ERRORED:
      return false;

    case constants.LOGOUT_SUCCESS:
      localStorage.removeItem('logged-in')
      localStorage.removeItem('user')
      return false;

    default:
      return state;
  }
}

export const pubPath = (state = '/login', action: AuthActions): string => {
  switch(action.type) {
    case constants.RESET_PASSWORD_ROUTE:
      return action.route;
    default:
      return state;
  }
}

export const resetConf = (state: IPasswordResetCredentilas = { password: '', uidb64: '', token: '' }, action: AuthActions): IPasswordResetCredentilas => {
  switch(action.type) {
    case constants.SET_RESET_CONF:
      return action.resetConf;
    default:
      return state;
  }
}
